// extracted by mini-css-extract-plugin
module.exports = {"input":"_1fFno"};